import { apiClient } from "./client";
import type {
  ExceptionsListResponse,
  ExceptionsSummaryResponse,
} from "./types";

export async function fetchExceptionsSummary(
  groupId: number,
): Promise<ExceptionsSummaryResponse> {
  const response = await apiClient.post<ExceptionsSummaryResponse>(
    `/v1/exceptions/summary/${groupId}`,
    [],
  );

  return response.data;
}

export async function fetchExceptionsList(
  wiid: number,
  groupId: number,
): Promise<ExceptionsListResponse> {
  const response = await apiClient.post<ExceptionsListResponse>(
    `/v1/exceptions/list/${wiid}/${groupId}`,
    [],
  );

  return response.data;
}
